<template>
  <LensCreationModal 
    v-if="stage === 'modal'" 
    @proceed="proceedToDrawer"
    @close="$emit('close')"
  />
  <LensCreationDrawer 
    v-else-if="stage === 'drawer'" 
    @created="$emit('created')"
    @close="$emit('close')"
  />
</template>

<script>
import LensCreationModal from './modal/LensCreationModal.vue'
import LensCreationDrawer from './drawer/LensCreationDrawer.vue'

export default {
  name: 'LensCreation',
  components: {
    LensCreationModal,
    LensCreationDrawer
  },
  data () {
    return {
      stage: 'modal' // 'modal' or 'drawer'
    }
  },
  methods: {
    proceedToDrawer () {
      this.stage = 'drawer'
    }
  }
}
</script>